import {
    current,
    calls,
    nextCalls,
    gameToGo,
    fireBallStatus,
} from '../../stores/backend';
import { BackendSocket } from '../../hooks/use-socket';
import { BingoCallMessage } from '../../types/bingo-events/in/backend/call-message';

export const onCallMessage = (socket: BackendSocket) => {
    const callback = (data: BingoCallMessage) => {
        const fireBall = current.fireball.value;

        if (fireBall) {
            if (
                fireBallStatus.value === 'pending' &&
                data.callNumber !== fireBall
            ) {
                fireBallStatus.set('snuffed');
            } else if (data.callNumber === fireBall) {
                fireBallStatus.set('pending');
            }
        }

        calls.set(data.callNumbers);
        nextCalls.set(data.nextCallballs);
        gameToGo.set(data.gameToGo || {});
        current.merge({
            current_part: data.part - 1,
        });
    };

    socket.on('bingo:callMessage', callback);

    return () => {
        socket.off('bingo:callMessage', callback);
    };
};
